import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalData extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			data:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(data){
		this.setState({
			show: true,
			data: data
		});
	}

	handleClose(){
		this.setState({
			show: false,
			data: "",
		});
	}


	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Notificacion de Compatibilidad (XML)</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<textarea className="form-control" style={{minHeight:"150px", height: "60vh",width:"100%",resize:"none"}}
		        				value={this.state.data} disabled />
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
			
	}
}

export default translate('translations') (ModalData)